export default "__VITE_ASSET__B5SrWB3n__"